import type { DownloadFileFunc, FilterParam } from '../../../../../../types';
import type { MappingContent, MappingFilterMappingItem } from '../types';

export function toApiMappingContent(
  mappingContent: MappingContent | undefined,
): DownloadFileFunc['mappingContent'] {
  if (!mappingContent) return undefined;

  return {
    ...mappingContent,
    mappingItems: mappingContent.mappingItems?.map(item => {
      const mapped = item as MappingFilterMappingItem;
      const filterParam: FilterParam | undefined = 'filterParam' in item ? mapped.filterParam : undefined;
      const filterValue =
        'filterValue' in item && mapped.filterValue != null && mapped.filterValue !== ''
          ? mapped.filterValue
          : item.id;

      return { filterParam, filterValue };
    }),
  };
}
